/**
 * @generated SignedSource<<24e8d432c592d7bc580c360cb85a941f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type endRentalPageDeactivateMutation$variables = {
  id: string;
};
export type endRentalPageDeactivateMutation$data = {
  readonly b2BLockReservationDeactivate: string;
};
export type endRentalPageDeactivateMutation = {
  response: endRentalPageDeactivateMutation$data;
  variables: endRentalPageDeactivateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "kind": "ScalarField",
    "name": "b2BLockReservationDeactivate",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "endRentalPageDeactivateMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "endRentalPageDeactivateMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "9bbf16f8b0e847d98b898d81c1733a67",
    "id": null,
    "metadata": {},
    "name": "endRentalPageDeactivateMutation",
    "operationKind": "mutation",
    "text": "mutation endRentalPageDeactivateMutation(\n  $id: UUID!\n) {\n  b2BLockReservationDeactivate(id: $id)\n}\n"
  }
};
})();

(node as any).hash = "28b6fe9c82d57a8595bfddc35819f9db";

export default node;
